import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  title: {
    margin: 0,
    marginLeft: 5,
  },
  materielRightHeader: {
    "& button": {
      padding: "8px !important",
    },
  },
  materielHeader: {
    padding: "6px !important",
  },
  bottomContent: {
    display: "flex",
  },
  tableContainer: {
    "& thead": {
      display: "none",
    },
    "& table": {
      borderSpacing: "0 10px",
      borderCollapse: "separate",
    },
    "& td": {
      borderTop: `1px solid ${theme.color.gray2}`,
      "&:first-child": {
        borderLeft: `1px solid ${theme.color.gray2}`,
      },
      "&:last-child": {
        borderRight: `1px solid ${theme.color.gray2}`,
      },
    },
  },
  productCartTable: {
    "& table td:nth-child(3)": {
      whiteSpace: "nowrap !important",
    },
  },
  CircularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  navigationStep: {
    marginTop: 18,
    marginBottom: 18,
    display: "flex",
    justifyContent: "space-between",
  },
  dialogContent: {
    textAlign: "center",
  },
  paperModal: {
    flex: "0 1 500px",
    width: 500,
    maxWidth: "100%",
  },
  CreateEdbPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
  MenuContainer: {
    "& .MuiListItemIcon-root": {
      minWidth: 30,
    },
    "& .MuiTypography-body1": {
      fontFamily: theme.font.workSans,
    },
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: 166,
      background: theme.color.white,
    },
  },
  productTableWrapper: {
    cursor: "pointer",
  },
  productDesignation: {
    fontWeight: 600,
    paddingBottom: 10,
    display: "box",
    maxHeight: 33,
    textOverflow: "ellipsis",
    overflow: "hidden",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 2,
  },
  cartContent: {
    display: "flex",
    flexDirection: "column",
  },
}));
